"use strict";
import React from "react";
import Account from "../../api/account";
import { History, Link } from "react-router";
function invoiceStatus(invoice) {
  return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-status-text" }, "Status: ", invoice.status);
}
function invoiceTitle(props) {
  if (Account.currentSettings().display_load_reference_as_title) {
    return null;
  }
  if (props.load.load.source_system === "hubtran") {
    return /* @__PURE__ */ React.createElement("div", null, "Editing Draft Load\xA0", /* @__PURE__ */ React.createElement("small", null, /* @__PURE__ */ React.createElement(Link, { to: assignLoadsUrl(props) }, "Go back and select a load")));
  }
  return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-header-text" }, "Load ", props.load.load.load_id);
}
function assignLoadsUrl(props) {
  return "/index-document-batches/" + props.batchId;
}
export default React.createClass({
  mixins: [History],
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__header" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-header" }, invoiceTitle(this.props)), !Account.auditBillingEnabled() && /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-status" }, invoiceStatus(this.props.carrierInvoice)));
  }
});
